export const STORES = {
	COMMUNITY_NODES: 'communityNodes',
	ROOT: 'root',
	SETTINGS: 'settings',
	UI: 'ui',
	USERS: 'users',
	WORKFLOWS: 'workflows',
	WORKFLOWS_LIST: 'workflowsList',
	WORKFLOWS_V2: 'workflowsV2',
	WORKFLOWS_EE: 'workflowsEE',
	WORKFLOW_DOCUMENTS: 'workflowDocuments',
	EXECUTION_DATA: 'executionData',
	WORKFLOW_EXECUTION_STATES: 'workflowExecutionStates',
	EXECUTIONS: 'executions',
	NDV: 'ndv',
	TEMPLATES: 'templates',
	NODE_TYPES: 'nodeTypes',
	CREDENTIALS: 'credentials',
	TAGS: 'tags',
	ANNOTATION_TAGS: 'annotationTags',
	VERSIONS: 'versions',
	NODE_CREATOR: 'nodeCreator',
	WEBHOOKS: 'webhooks',
	HISTORY: 'history',
	CLOUD_PLAN: 'cloudPlan',
	RBAC: 'rbac',
	PUSH: 'push',
	COLLABORATION: 'collaboration',
	ASSISTANT: 'assistant',
	BUILDER: 'builder',
	CHAT_PANEL: 'chatPanel',
	CHAT_PANEL_STATE: 'chatPanelState',
	BECOME_TEMPLATE_CREATOR: 'becomeTemplateCreator',
	PROJECTS: 'projects',
	API_KEYS: 'apiKeys',
	EVALUATION: 'evaluation',
	FOLDERS: 'folders',
	MODULES: 'modules',
	FOCUS_PANEL: 'focusPanel',
	AI_TEMPLATES_STARTER_COLLECTION: 'aiTemplatesStarterCollection',
	PERSONALIZED_TEMPLATES: 'personalizedTemplates',
	EXPERIMENT_READY_TO_RUN_WORKFLOWS: 'readyToRunWorkflows',
	EXPERIMENT_READY_TO_RUN_WORKFLOWS_V2: 'readyToRunWorkflowsV2',
	EXPERIMENT_TEMPLATE_RECO_V2: 'templateRecoV2',
	PERSONALIZED_TEMPLATES_V3: 'personalizedTemplatesV3',
	READY_TO_RUN: 'readyToRun',
	TEMPLATES_DATA_QUALITY: 'templatesDataQuality',
	BANNERS: 'banners',
	CONSENT: 'consent',
	CHAT_HUB: 'chatHub',
	CHAT_HUB_PANEL: 'chatHubPanel',
	EXPERIMENT_EMPTY_STATE_BUILDER_PROMPT: 'emptyStateBuilderPrompt',
	EXPERIMENT_CREDENTIALS_APP_SELECTION: 'credentialsAppSelection',
	EXPERIMENT_SURFACE_MCP_TO_NEW_CLOUD_USERS: 'surfaceMcpToNewCloudUsers',
	SETUP_PANEL: 'setupPanel',
	FOCUSED_NODES: 'focusedNodes',
	FAVORITES: 'favorites',
	AI_GATEWAY: 'aiGateway',
	EVALUATIONS_WIZARD_SIDEPANEL: 'evaluationsWizardSidepanel',
} as const;
